import { ConditionType, DEFAULT_OPT_OUT_NEGATE_WORDING, OptOutRow as SharedOptOutRow } from '@/features/dryad';
import { ConditionTypeSelect } from './condition-type-select';

type OptOutRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/** The people surface's binding of the shared opt-out row. */
export function OptOutRow({ id }: OptOutRowProps) {
  return (
    <SharedOptOutRow
      id={id}
      conditionType={ConditionType.OptOut}
      negateWording={DEFAULT_OPT_OUT_NEGATE_WORDING}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.OptOut} />}
    />
  );
}
